import { combineReducers } from 'redux';
import auth from './auth/reducer';
import propostas from './propostas/reducer';

export default combineReducers({
  auth,
  propostas,
});
